<template>
    <div>
        <div class="header_content">
            <h2>{{ activeTab.config.headline }}</h2>
            <div class="icon_container" title="Tabelle neu laden" @click="reFetch">
                <unicon name="redo" fill="#394956" hover-fill="#00B6ED" style="cursor: pointer"></unicon>
            </div>
        </div>
        <div class="content">
            <AdaButton style="z-index: 5000000" v-if="isAdmin || (item && item.id === 'advertisers')" class="addButton"
                       :title="activeTab.config.add_button"
                       @click="openAddDialog" icon="icon-add"></AdaButton>
            <AdaTableClient :columns="getColumns" :data-loading="fetching" :rows="activeRows"
                            :transformers="transformers" :sort-key="activeTab.config.sortKey"
                            :class="'table_'+item.id" :table-length="50"
                            @rowClicked="rowClicked"></AdaTableClient>
            <div style="margin-top:5rem; color: #a9a9a9"
                 v-if="['users', 'devices', 'brandings', 'dealTypes', 'salesoffices', 'placements', 'formats', 'seats',
                 'targetings', 'reportings', 'advertisers'].includes(item.id)">
                *Gibt an, ob die Daten in dem Deal Instructor Dropdown auftauchen. Die Einträge, die <b>nicht</b> im
                Deal Instructor angezeigt werden, werden in grauer Schrift angezeigt.
            </div>
        </div>
        <!-- ADD DIALOG -->
        <Dialog :show="showAddDialog" @close="closeAddDialog" :show-close-button="true">
            <div class="dialog_content">
                <h4>{{ activeTab.config.add_dialog_headline }}</h4>
                <div class="content">
                    <div v-if="item && item.id !== 'seats'">
                        <Input v-for="(value, name, i) in getDataWithoutInDeallistAttr" :key="'input_'+i"
                               :label="getLabel(name)"
                               v-model="activeTab.data[name]"
                               @enter="addItem"
                        ></Input>
                    </div>

                    <!-- SEATS -->
                    <div v-else>
                        <Input label="Seat Name"
                               v-model="activeTab.data.name"
                               @enter="addItem"
                        ></Input>
                        <Input label="Seat ID"
                               v-model="activeTab.data.seat_id"
                               @enter="addItem"
                        ></Input>
                        <Dropdown label="SSP"
                                  :items="[{name:'Google'}, {name:'Yieldlab'}, {name:'Xandr'}, {name:'SmartX'}]"
                                  :select-on-click="true"
                                  :editable="true"
                                  @enter="activeTab.data.ssp = $event.name"></Dropdown>
                        <Dropdown label="DSP"
                                  :items="$store.getters['settings/distinctDSPs']"
                                  :select-on-click="true"
                                  :editable="true"
                                  @enter="activeTab.data.dsp = typeof $event.edited !== 'undefined' ? $event.edited : $event.name"></Dropdown>
                        <Input label="Agenturgruppe"
                               v-model="activeTab.data.agency_group"
                               @enter="addItem"
                        ></Input>
                        <Input label="Agentur"
                               v-model="activeTab.data.agency"
                               @enter="addItem"
                        ></Input>
                    </div>

                    <!-- conditional USERS -->
                    <div v-if="item && item.id === 'users'" style="margin-top: 2rem; margin-bottom: 1rem;">
                        <label>Rolle</label>
                        <RadioButton id="role_user" title="User" :value="activeTab.data['role'] === 'user'"
                                     :rounded="true"
                                     @change="activeTab.data['role'] = 'user'"></RadioButton>
                        <RadioButton id="role_admin" title="Admin" :value="activeTab.data['role'] === 'admin'"
                                     :rounded="true"
                                     @change="activeTab.data['role'] = 'admin'"></RadioButton>
                    </div>

                    <!-- conditional NOT GROUPS -->
                    <div v-if="item && item.id !== 'groups'" style="margin-top: 2rem; margin-bottom: 1rem;">
                        <label>Im Deal Instructor anzeigen ? </label>
                        <RadioButton id="dl_create_yes" title="Ja" :value="activeTab.data['in_deallist'] === 1"
                                     :rounded="true" :disabled="item && item.id === 'advertisers'"
                                     @change="activeTab.data['in_deallist'] = 1"></RadioButton>
                        <RadioButton id="dl_create_no" title="Nein" :value="activeTab.data['in_deallist'] === 0"
                                     :rounded="true" :disabled="item && item.id === 'advertisers'"
                                     @change="activeTab.data['in_deallist'] = 0"></RadioButton>
                    </div>
                </div>
                <div class="button_container">
                    <AdaButton title="Speichern" :loading="actionLoading" @click="addItem"></AdaButton>
                    <AdaButton type="grey" title="Abbrechen" @click="closeAddDialog"></AdaButton>
                </div>
            </div>
        </Dialog>


        <!-- EDIT DIALOG -->
        <Dialog :show="showEditDialog" @close="closeEditDialog" :show-close-button="true">
            <div class="dialog_content">
                <h4>{{ activeTab.config.edit_dialog_headline }}</h4>
                <div class="content">
                    <div v-if="item && item.id !== 'seats'">
                        <Input v-for="(value, name, i) in getDataWithoutInDeallistAttr" :key="'input_'+i"
                               :label="getLabel(name)"
                               v-model="activeTab.data[name]"
                               @enter="editItem"
                        ></Input>
                    </div>

                    <!-- SEATS -->
                    <div v-else>
                        <Input label="Seat Name"
                               v-model="activeTab.data.name"
                               @enter="addItem"
                        ></Input>
                        <Input label="Seat ID"
                               v-model="activeTab.data.seat_id"
                               @enter="addItem"
                        ></Input>
                        <Dropdown label="DSP"
                                  :items="$store.getters['settings/distinctDSPs']"
                                  :select-on-click="true"
                                  :editable="true"
                                  :initial="activeTab.data.dsp"
                                  @enter="activeTab.data.dsp = typeof $event.edited !== 'undefined' ? $event.edited : $event.name"></Dropdown>
                        <Dropdown label="SSP"
                                  :items="[{name:'Google'}, {name:'Yieldlab'}, {name:'Xandr'}, {name:'SmartX'}]"
                                  :select-on-click="true"
                                  :editable="true"
                                  :initial="activeTab.data.ssp"
                                  @enter="activeTab.data.ssp = $event.name"></Dropdown>
                        <Input label="Agenturgruppe"
                               v-model="activeTab.data.agency_group"
                               @enter="addItem"
                        ></Input>
                        <Input label="Agentur"
                               v-model="activeTab.data.agency"
                               @enter="addItem"
                        ></Input>
                    </div>

                    <!-- conditional USERS -->
                    <div v-if="item && item.id === 'users'" style="margin-top: 2rem; margin-bottom: 1rem;">
                        <label>Rolle</label>
                        <RadioButton id="role_user" title="User" :value="activeTab.data['role'] === 'user'"
                                     :rounded="true"
                                     @change="activeTab.data['role'] = 'user'"></RadioButton>
                        <RadioButton id="role_admin" title="Admin" :value="activeTab.data['role'] === 'admin'"
                                     :rounded="true"
                                     @change="activeTab.data['role'] = 'admin'"></RadioButton>
                    </div>

                    <!-- IN DEALLIST RADIO BUTTONS -->
                    <div v-if="item && item.id !== 'groups'" style="margin-top: 2rem; margin-bottom: 1rem;">
                        <label>Im Deal Instructor anzeigen ?</label>
                        <RadioButton id="dl_edit_yes" title="Ja" :value="activeTab.data['in_deallist'] === 1"
                                     :rounded="true"
                                     @change="activeTab.data['in_deallist'] = 1"></RadioButton>
                        <RadioButton id="dl_edit_no" title="Nein" :value="activeTab.data['in_deallist'] === 0"
                                     :rounded="true"
                                     @change="activeTab.data['in_deallist'] = 0"></RadioButton>
                    </div>
                </div>
                <div class="button_container">
                    <AdaButton title="Speichern" :loading="actionLoading" @click="editItem"></AdaButton>
                    <AdaButton type="grey" title="Abbrechen" @click="closeEditDialog"></AdaButton>
                </div>
            </div>
        </Dialog>
        <!-- DELETE DIALOG -->
        <Confirm :show="showDeleteConfirm" :closeable="true" :ok-loading="actionLoading" @close="closeDeleteConfirm"
                 :title="activeTab.config.delete_dialog_headline" @onok="deleteItem" @oncancel="closeDeleteConfirm"
                 :options="{
                confirm: {
                    title: 'Löschen',
                    icon: 'icon-delete',
                    color: 'pink'
                },
                cancel: {
                    title: 'Abbrechen',
                    icon: 'icon-close',
                    color: 'grey'
                }
            }"
        >
            <div class="deleteDialog">
                <div :style="{width: '500px'}">{{getDeleteText}}</div>
            </div>
        </Confirm>
    </div>
</template>

<script>
import AdaTableClient from "../../components/dataTable/AdaTableClient";
import AdaButton from "../../components/buttons/AdaButton";
import Dialog from "../../components/dialogs/Dialog";
import Input from "../../components/inputs/Input";
import Confirm from "../../components/dialogs/Confirm";
import moment from 'moment';
import RadioButton from "@/components/inputs/RadioButton";
import Dropdown from "@/components/inputs/DropDown";

export default {
    name: "SettingsTable",
    components: {Dropdown, RadioButton, Confirm, Input, Dialog, AdaButton, AdaTableClient},
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showAddDialog: false,
            showEditDialog: false,
            showDeleteConfirm: false,
            forceFetch: false,
            clickedRow: null,
            groups: {
                config: {
                    fetch: 'settings/fetchGroups',
                    onAdd: 'settings/createGroup',
                    onEdit: 'settings/updateGroup',
                    onDelete: 'settings/deleteGroup',
                    storeVariable: 'groups',
                    sortKey: 'name',
                    add_button: 'Gruppe hinzufügen',
                    headline: 'Gruppen verwalten',
                    add_dialog_headline: 'Neue Gruppe hinzufügen',
                    edit_dialog_headline: 'Gruppe editieren',
                    delete_dialog_headline: 'Gruppe löschen',
                },
                data: {name: null}
            },
            users: {
                config: {
                    fetch: 'settings/fetchUsers',
                    onAdd: 'settings/createUser',
                    onEdit: 'settings/updateUser',
                    onDelete: 'settings/deleteUser',
                    storeVariable: 'users',
                    sortKey: 'prio',
                    add_button: 'Benutzer hinzufügen',
                    headline: 'Benutzer verwalten',
                    add_dialog_headline: 'Neuen Benutzer hinzufügen',
                    edit_dialog_headline: 'Benutzer editieren',
                    delete_dialog_headline: 'Benutzer löschen',
                },
                data: {first_name: null, last_name: null, email: null, role: 'user', prio: null, in_deallist: 1}
            },
            devices: {
                config: {
                    fetch: 'settings/fetchDevices',
                    onAdd: 'settings/createDevice',
                    onEdit: 'settings/updateDevice',
                    onDelete: 'settings/deleteDevice',
                    storeVariable: 'devices',
                    sortKey: 'prio',
                    add_button: 'Device hinzufügen',
                    headline: 'Devices verwalten',
                    add_dialog_headline: 'Neues Device hinzufügen',
                    edit_dialog_headline: 'Device editieren',
                    delete_dialog_headline: 'Device löschen',
                },
                data: {name: null, display_name: null, in_deallist: 1, prio: null}

            },
            formats: {
                config: {
                    fetch: 'settings/fetchFormats',
                    onAdd: 'settings/createFormat',
                    onEdit: 'settings/updateFormat',
                    onDelete: 'settings/deleteFormat',
                    storeVariable: 'formats',
                    sortKey: 'prio',
                    headline: 'Formate verwalten',
                    add_button: 'Format hinzufügen',
                    add_dialog_headline: 'Neues Format hinzufügen',
                    edit_dialog_headline: 'Format editieren',
                    delete_dialog_headline: 'Format löschen'
                },
                data: {name: null, display_name: null, sizes: null, in_deallist: 1, prio: null}
            },
            placements: {
                config: {
                    fetch: 'settings/fetchPlacements',
                    onAdd: 'settings/createPlacement',
                    onEdit: 'settings/updatePlacement',
                    onDelete: 'settings/deletePlacement',
                    storeVariable: 'placements',
                    sortKey: 'prio',
                    headline: 'Placements verwalten',
                    add_button: 'Placement hinzufügen',
                    add_dialog_headline: 'Neues Placement hinzufügen',
                    edit_dialog_headline: 'Placement editieren',
                    delete_dialog_headline: 'Placement löschen'
                },
                data: {name: null, display_name: null, in_deallist: 1, prio: null}
            },
            salesoffices: {
                config: {
                    fetch: 'settings/fetchSalesoffices',
                    onAdd: 'settings/createSalesoffice',
                    onEdit: 'settings/updateSalesoffice',
                    onDelete: 'settings/deleteSalesoffice',
                    storeVariable: 'salesoffices',
                    sortKey: 'prio',
                    headline: 'Verkaufsbüros verwalten',
                    add_button: 'Verkaufsbüro hinzufügen',
                    add_dialog_headline: 'Neues Verkaufsbüro hinzufügen',
                    edit_dialog_headline: 'Verkaufsbüro editieren',
                    delete_dialog_headline: 'Verkaufsbüro löschen',
                },
                data: {name: null, display_name: null, in_deallist: 1, prio: null}
            },
            brandings: {
                config: {
                    fetch: 'settings/fetchBrandings',
                    onAdd: 'settings/createBranding',
                    onEdit: 'settings/updateBranding',
                    onDelete: 'settings/deleteBranding',
                    storeVariable: 'brandings',
                    sortKey: 'prio',
                    headline: 'Transparenz verwalten',
                    add_button: 'Transparenz hinzufügen',
                    add_dialog_headline: 'Neue Transparenz hinzufügen',
                    edit_dialog_headline: 'Transparenz editieren',
                    delete_dialog_headline: 'Transparenz löschen',
                },
                data: {name: null, in_deallist: 1, prio: null}
            },
            dealTypes: {
                config: {
                    fetch: 'settings/fetchDealTypes',
                    onAdd: 'settings/createDealType',
                    onEdit: 'settings/updateDealType',
                    onDelete: 'settings/deleteDealType',
                    storeVariable: 'dealTypes',
                    sortKey: 'prio',
                    headline: 'Deal Types verwalten',
                    add_button: 'Deal Type hinzufügen',
                    add_dialog_headline: 'Neuen Deal Type hinzufügen',
                    edit_dialog_headline: 'Deal Type editieren',
                    delete_dialog_headline: 'Deal Type löschen',
                },
                data: {name: null, display_name: null, in_deallist: 1, prio: null}
            },
            seats: {
                config: {
                    fetch: 'settings/fetchSeats',
                    onAdd: 'settings/createSeat',
                    onEdit: 'settings/updateSeat',
                    onDelete: 'settings/deleteSeat',
                    storeVariable: 'seats',
                    sortKey: 'name',
                    headline: 'Seats verwalten',
                    add_button: 'Seat hinzufügen',
                    add_dialog_headline: 'Neuen Seat hinzufügen',
                    edit_dialog_headline: 'Seat editieren',
                    delete_dialog_headline: 'Seat löschen',
                },
                data: {
                    name: null,
                    seat_id: null,
                    ssp: null,
                    dsp: null,
                    agency_group: null,
                    agency: null,
                    in_deallist: 1
                }
            },
            targetings: {
                config: {
                    fetch: 'settings/fetchTargetings',
                    onAdd: 'settings/createTargeting',
                    onEdit: 'settings/updateTargeting',
                    onDelete: 'settings/deleteTargeting',
                    storeVariable: 'targetings',
                    sortKey: 'prio',
                    headline: 'Targetings verwalten',
                    add_button: 'Targeting hinzufügen',
                    add_dialog_headline: 'Neues Targeting hinzufügen',
                    edit_dialog_headline: 'Targeting editieren',
                    delete_dialog_headline: 'Targeting löschen',
                },
                data: {
                    genre: null,
                    in_di: null,
                    in_dealname: null,
                    kv_google: null,
                    kv_yieldlab: null,
                    kv_xandr: null,
                    prio: null,
                    in_deallist: 1
                }
            },
            reportings: {
                config: {
                    fetch: 'settings/fetchReportings',
                    onAdd: 'settings/createReporting',
                    onEdit: 'settings/updateReporting',
                    onDelete: 'settings/deleteReporting',
                    storeVariable: 'reportings',
                    sortKey: 'prio',
                    headline: 'Reportings verwalten',
                    add_button: 'Reporting hinzufügen',
                    add_dialog_headline: 'Neues Reporting hinzufügen',
                    edit_dialog_headline: 'Reporting editieren',
                    delete_dialog_headline: 'Reporting löschen',
                },
                data: {name: null, in_deallist: 1, prio: null}
            },
            advertisers: {
                config: {
                    fetch: 'settings/fetchAdvertisers',
                    onAdd: 'settings/createAdvertiser',
                    onEdit: 'settings/updateAdvertiser',
                    onDelete: 'settings/deleteAdvertiser',
                    storeVariable: 'advertisers',
                    sortKey: 'advertiser_name',
                    headline: 'Advertisers verwalten',
                    add_button: 'Advertiser hinzufügen',
                    add_dialog_headline: 'Neuen Advertiser hinzufügen',
                    edit_dialog_headline: 'Advertiser editieren',
                    delete_dialog_headline: 'Advertiser löschen',
                },
                data: {advertiser_name: null, in_deallist: 1}
            },
            transformers: [
                {
                    propName: 'action',
                    transform: function (value) {
                        let res = '';
                        value.forEach(action => {
                            switch (action) {
                                case 'delete':
                                    res += '<span style="cursor: pointer" data-type="delete" class="icon icon-delete"></span>';
                                    break;
                                case 'edit':
                                    res += '<span style="cursor: pointer" data-type="edit" class="icon icon-edit"></span>';
                                    break;
                            }
                        });
                        return res;
                    }
                },
                {
                    propName: 'in_deallist',
                    transform: function (value) {
                        if (value === 0) {
                            return '<div style="text-align:center;color: #a9a9a9"><span class="icon icon-close"></span></div>'
                        } else if (value === 1) {
                            return '<div style="text-align:center; color:green;"><span class="icon icon-apply"></span></div>'
                        }
                    }
                },
                {
                    propName: 'created_at',
                    transform: function (value) {
                        let ret = value;
                        if (typeof value !== "undefined") {
                            ret = moment(value, moment.ISO_8601).format('DD.MM.YYYY');
                        }
                        return ret;
                    }
                }
            ],
        };
    },
    mounted() {
        if (this.vuexState[this.activeTab.config.storeVariable] === null) {
            this.fetch();
        }
    },
    computed: {
        columns() {
            return [
                {
                    name: 'groups',
                    columns: [
                        {width: this.isAdmin ? '99%' : '100%', label: 'Name', name: 'name'},
                        {width: '1%', label: 'Aktionen', name: 'action'},
                    ]
                },
                {
                    name: 'users',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '15%', label: 'Vorname', name: 'first_name'},
                        {width: '15%', label: 'Nachname', name: 'last_name'},
                        {width: '25%', label: 'E-Mail', name: 'email'},
                        {width: '10%', label: 'Rolle', name: 'role'},
                        {
                            width: this.isAdmin ? '35%' : '35%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
                {
                    name: 'devices',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '20%', label: 'Name', name: 'name'},
                        {width: '20%', label: 'Anzeige Name', name: 'display_name'},
                        {
                            width: this.isAdmin ? '59%' : '60%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
                {
                    name: 'formats',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '20%', label: 'Name', name: 'name'},
                        {width: '20%', label: 'Anzeige Name', name: 'display_name'},
                        {width: '35%', label: 'Sizes', name: 'sizes'},
                        {
                            width: this.isAdmin ? '24%' : '25%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
                {
                    name: 'placements',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '20%', label: 'Name', name: 'name'},
                        {width: '20%', label: 'Anzeige Name', name: 'display_name'},
                        {
                            width: this.isAdmin ? '59%' : '60%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
                {
                    name: 'salesoffices',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '20%', label: 'Name', name: 'name'},
                        {width: '20%', label: 'Anzeige Name', name: 'display_name'},
                        {
                            width: this.isAdmin ? '59%' : '60%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ]
                },
                {
                    name: 'brandings',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '20%', label: 'Name', name: 'name'},
                        {
                            width: this.isAdmin ? '79%' : '80%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
                {
                    name: 'dealTypes',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '15%', label: 'Name', name: 'name'},
                        {width: '20%', label: 'Anzeige Name', name: 'display_name'},
                        {
                            width: this.isAdmin ? '64%' : '65%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
                {
                    name: 'seats',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '35%', label: 'Seat', name: 'name'},
                        {width: this.isAdmin ? '10%' : '9%', label: 'Seat ID', name: 'seat_id'},
                        {width: this.isAdmin ? '10%' : '9%', label: 'SSP', name: 'ssp'},
                        {width: this.isAdmin ? '17%' : '15%', label: 'DSP', name: 'dsp'},
                        {width: this.isAdmin ? '14%' : '16%', label: 'Agenturgruppe', name: 'agency_group'},
                        {width: this.isAdmin ? '14%' : '16%', label: 'Agentur', name: 'agency'},
                        {width: '1%', label: 'Aktion', name: 'action'},
                    ],
                },
                {
                    name: 'targetings',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '10%', label: 'Genre', name: 'genre'},
                        {width: this.isAdmin ? '20%' : '10%', label: 'Auswahl im DI', name: 'in_di'},
                        {width: this.isAdmin ? '10%' : '10%', label: 'Abk. im Dealnamen', name: 'in_dealname'},
                        {width: this.isAdmin ? '19%' : '23%', label: 'KeyValue Google', name: 'kv_google'},
                        {width: this.isAdmin ? '19%' : '23%', label: 'KeyValue Yieldlab', name: 'kv_yieldlab'},
                        {width: this.isAdmin ? '20%' : '24%', label: 'KeyValue Xandr', name: 'kv_xandr'},
                        {
                            width: '1%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: '1%', label: 'Aktion', name: 'action'},
                    ],
                },
                {
                    name: 'reportings',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: '20%', label: 'Name', name: 'name'},
                        {
                            width: this.isAdmin ? '79%' : '80%',
                            label: 'Pos.',
                            tooltip: 'Position im Deal Instructor Dropdown',
                            name: 'prio',
                            type: 'naturalNumber'
                        },
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
                {
                    name: 'advertisers',
                    columns: [
                        {
                            width: '50px',
                            label: 'DI*',
                            tooltip: 'Eintrag wird im Deal Instructor angezeigt',
                            name: 'in_deallist'
                        },
                        {width: this.isAdmin ? '99%' : '100%', label: 'Name', name: 'advertiser_name'},
                        {width: this.isAdmin ? '1%' : '0%', label: 'Aktionen', name: 'action'},
                    ],
                },
            ]
        },
        vuexState() {
            return this.$store.state.settings;
        },
        fetching() {
            return this.vuexState.fetching[this.item.id];
        },
        actionLoading() {
            return this.vuexState.actionLoading;
        },
        activeTab() {
            return this[this.item.id]
        },
        activeRows() {
            let rows = this.vuexState[this.activeTab.config.storeVariable] !== null ? JSON.parse(JSON.stringify(this.vuexState[this.activeTab.config.storeVariable])) : [];
            rows.forEach((row) => {
                row.action = ['edit', 'delete'];
            });
            return rows;
        },
        getDeleteText() {
            if (this.clickedRow) {
                if (this.item.id === 'groups') {
                    return 'Presets die, dieser Gruppe zugeordnet sind, werden danach keiner Gruppe zugeordnet.<br>' +
                        'Diese Aktion kann nicht mehr rückgängig gemacht werden.<br><br>' +
                        'Die Gruppe <b>\'' + this.clickedRow.name + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'users') {
                    return 'Es werden sämtliche Presets, die mit diesem Benutzer in Verbindung stehen, auch gelöscht.<br>' +
                        'Diese Aktion kann nicht mehr rückgängig gemacht werden.<br><br> ' +
                        'Den Benutzer mit der E-Mail <b>\'' + this.clickedRow.email + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'devices') {
                    return 'Das Device <b>\'' + this.clickedRow.name + '\'</b>' + (this.clickedRow.display_name && this.clickedRow.name !== this.clickedRow.display_name ? ((' bzw. <b>\'' + this.clickedRow.display_name) + '\'</b>') : "") + ' wirklich löschen ?';
                } else if (this.item.id === 'formats') {
                    return 'Das Format <b>\'' + this.clickedRow.name +
                        (this.clickedRow.display_name ? ' | ' + this.clickedRow.display_name : '') +
                        (this.clickedRow.sizes ? ' | ' + this.clickedRow.sizes : '') + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'placements') {
                    return 'Das Placement <b>\'' + this.clickedRow.name + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'salesoffices') {
                    return 'Das Verkaufsbüro <b>\'' + this.clickedRow.name + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'brandings') {
                    return 'Die Transparenz <b>\'' + this.clickedRow.name + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'dealTypes') {
                    return 'Den Deal Type <b>\'' + this.clickedRow.name + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'reportings') {
                    return 'Das Reporting <b>\'' + this.clickedRow.name + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'advertisers') {
                    return 'Den Advertiser <b>\'' + this.clickedRow.advertiser_name + '\'</b> wirklich löschen ?';
                } else if (this.item.id === 'seats') {
                    return 'Den Seat wirklich löschen ?<br><br>' +
                        '<div class="row"><div class="col-1">Name:</div>' + this.clickedRow.name +
                        '</div><div class="row"><div class="col-1">Seat ID:</div>' + this.clickedRow.seat_id +
                        '</div><div class="row"><div class="col-1">SSP:</div>' + this.clickedRow.ssp +
                        '</div><div class="row"><div class="col-1">DSP:</div>' + this.clickedRow.dsp +
                        '</div><div class="row"><div class="col-1">Agenturgruppe:</div>' + this.clickedRow.agency_group +
                        '</div><div class="row"><div class="col-1">Agentur:</div>' + this.clickedRow.agency + '</div><br>';
                } else if (this.item.id === 'targetings') {
                    return 'Das Targeting wirklich löschen ?<br><br>' +
                        '<div class="row"><div class="col-1">Genre:</div>' + this.clickedRow.genre +
                        '</div><div class="row"><div class="col-1">Auswal im DI:</div>' + this.clickedRow.in_di +
                        '</div><div class="row"><div class="col-1">Abkz. im Dealnamen:</div>' + this.clickedRow.in_dealname +
                        '</div><div class="row"><div class="col-1">KeyValue Google:</div>' + this.clickedRow.kv_google +
                        '</div><div class="row"><div class="col-1">KeyValue Yieldlab:</div>' + this.clickedRow.kv_yieldlab +
                        '</div><div class="row"><div class="col-1">KeyValue Xandr:</div>' + this.clickedRow.kv_xandr + '</div><br>';
                }
            }
            return '';
        },
        isAdmin() {
            let user = this.$store.state.users.currentUser;
            return user && user.role === "admin";
        },
        getColumns() {
            return this.isAdmin || this.item.id === "advertisers" ? this.columns.find(x => x.name === this.item.id).columns : this.columns.find(x => x.name === this.item.id).columns.filter(x => x.name !== 'action');
        },
        getDataWithoutInDeallistAttr() {
            let asArray = Object.entries(this.activeTab.data);
            let filtered = asArray.filter(([key]) => key !== 'in_deallist' && key !== 'role');
            return Object.fromEntries(filtered);
        }
    },
    methods: {
        async fetch() {
            if (this.vuexState[this.activeTab.config.storeVariable] === null || this.forceFetch) {
                this.forceFetch = false;
                await this.$store.dispatch(this.activeTab.config.fetch);
            }
        },
        reFetch() {
            this.forceFetch = true;
            this.fetch();
        },
        async addItem() {
            if (this.validateData()) {
                await this.$store.dispatch(this.activeTab.config.onAdd, this.activeTab.data);
            }
        },
        async editItem() {
            if (this.validateData()) {
                let data = JSON.parse(JSON.stringify(this.activeTab.data));
                data.id = this.clickedRow.id;
                await this.$store.dispatch(this.activeTab.config.onEdit, data);
            }
        },
        async deleteItem() {
            if (this.clickedRow) {
                await this.$store.dispatch(this.activeTab.config.onDelete, this.clickedRow.id);
            } else {
                this.$noty.error('Es ist ein Fehler aufgetreten.');
            }
        },
        validateData() {
            let ignore = [{name: 'targetings', nullable: ['kv_google', 'kv_yieldlab', 'kv_xandr']}];
            let valid = true;
            for (let entry in this.activeTab.data) {
                let ignoredItem = ignore.find(x => x.name === this.item.id);
                let doIgnore = ignoredItem && ignoredItem.nullable.includes(entry) || entry === 'prio';
                if (!doIgnore && typeof this.activeTab.data[entry] !== "undefined" && (this.activeTab.data[entry] === null || this.activeTab.data[entry] === "")) {
                    valid = false;
                    this.$noty.warning('Bitte alle Felder ausfüllen.');
                    break;
                }
                if (valid && entry === 'email' && !this.validateEmail(this.activeTab.data[entry])) {
                    valid = false;
                    this.$noty.warning('Bitte eine gültige E-Mail angeben.');
                }
            }
            return valid;
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        getLabel(inputName) {
            let column = this.columns.find(x => x.name === this.item.id).columns.find(x => x.name === inputName);
            return column ? column.label : inputName;
        },
        openAddDialog() {
            for (let entry in this.activeTab.data) {
                this.activeTab.data[entry] = entry === 'in_deallist' ? 1 : (entry === 'role' ? 'user' : null);
            }
            this.showAddDialog = true;
        },
        closeAddDialog() {
            this.showAddDialog = false;
            for (let entry in this.activeTab.data) {
                this.activeTab.data[entry] = null;
            }
        },
        openEditDialog() {
            for (let entry in this.activeTab.data) {
                this.activeTab.data[entry] = this.clickedRow[entry];
            }
            this.showEditDialog = true;
        },
        closeEditDialog() {
            this.showEditDialog = false;
            for (let entry in this.activeTab.data) {
                this.activeTab.data[entry] = null;
            }
        },
        closeDeleteConfirm() {
            this.showDeleteConfirm = false;
            this.clickedRow = null;
        },
        rowClicked(data) {
            this.clickedRow = data.row;
            if (data.column.name === 'action') {
                let dataType = data.event.target.getAttribute('data-type');
                if (dataType === 'delete') {
                    this.showDeleteConfirm = true;
                } else if (dataType === 'edit') {
                    this.openEditDialog();
                }
            } else if (this.isAdmin) {
                this.openEditDialog();
            }
        }
    },
    watch: {
        item(newVal, oldVal) {
            if (newVal.name !== oldVal.name) {
                this.fetch();
            }
        },
        actionLoading(newVal) {
            if (!newVal && !this.vuexState.actionFailed) {
                if (this.showAddDialog) {
                    this.closeAddDialog();
                } else if (this.showDeleteConfirm) {
                    this.closeDeleteConfirm();
                } else if (this.showEditDialog) {
                    this.closeEditDialog();
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
h2 {
    margin-top: 0;
    font-weight: 500;
}

.header_content {
    display: flex;
    flex-flow: row;

    .icon_container {
        position: relative;
        top: 2px;
        margin-left: 10px;
    }
}

.content {
    position: relative;

    .addButton {
        position: absolute;
        right: 0;
    }
}

.dialog_content {
    display: flex;
    flex-flow: column;

    .button_container {
        display: flex;
        flex-flow: row;
        margin-top: 20px;

        > div:not(:last-child) {
            margin-right: 20px;
        }
    }
}

:deep( .deleteDialog .row ){
    display: flex;
    margin-bottom: 5px;

    .col-1 {
        font-weight: bold;
        min-width: 9rem;
    }
}

:deep(.table_users),
:deep(.table_devices),
:deep(.table_brandings),
:deep(.table_dealTypes),
:deep(.table_salesoffices),
:deep(.table_placements),
:deep(.table_formats),
:deep(.table_seats),
:deep(.table_targetings),
:deep(.table_reportings),
:deep(.table_advertisers) {
    tr {
        cursor: pointer;
    }

    tr.not_in_deallist {
        color: #a9a9a9;
    }
}


:deep(.table_targetings .table ){
    border-collapse: collapse;

    tbody tr.first_of_genre {
        border-top: 1px solid #78909C;
    }
}

:deep(.table.data-table tbody tr) {
    td {
        white-space: pre-wrap;
    }
}

</style>